/**
 * Normalizes a portalPath from the navObj into an absolute route path.
 *
 * Portal paths stored in Firestore use relative prefixes (e.g. "../../../../{uid}/onboarding")
 * that were resolved by TanStack Router's `from:` option. Since TanStack Router v1.163+
 * requires literal route types for `from`, we strip the relative segments and ensure
 * the path starts with "/" so it's treated as absolute.
 */
export function normalizePortalPath(portalPath: string): string {
  // Strip all leading "../" segments
  const stripped = portalPath.replace(/^(\.\.\/)+/, '');
  // Ensure leading slash
  return stripped.startsWith('/') ? stripped : `/${stripped}`;
}
